import styled from 'styled-components';

import type { PlanTodo } from './plan';
import { PlanTodoItem } from './plan-todo-item';

export type PlanTodoListProps = {
  todos: PlanTodo[];
};

export const PlanTodoList = ({ todos }: PlanTodoListProps) => {
  return (
    <TodoList>
      {todos.map((todo, index) => {
        const isFirst = index === 0;
        const isLast = index === todos.length - 1;
        return <PlanTodoItem key={todo.id} todo={todo} isFirst={isFirst} isLast={isLast} />;
      })}
    </TodoList>
  );
};

const TodoList = styled.ul({
  listStyle: 'none',
  margin: 0,
  padding: 0,
});
